
































import {
  defineComponent,
  ref,
  computed,
} from "@nuxtjs/composition-api";
import { SfTopBar, SfButton, SfOverlay } from "@storefront-ui/vue";
import { useTopBar } from "./useTopBar";
import type { ProductInterface } from "~/modules/GraphQL/types";
import { clickOutside } from "~/components/directives/click-outside/click-outside-directive";
import RelatedSite from "~/components/General/RelatedSite.vue";

import Login from "~/components/General/Login.vue"; 

export default defineComponent({
  components: {
    CurrencySelector: () => import("../CurrencySelector.vue"),
    StoreSwitcher: () => import("../StoreSwitcher.vue"),
    SfTopBar,
    // SfButton,
    SearchBar: () => import("~/components/Header/SearchBar/SearchBar.vue"),
    RelatedSite,
    // SvgImage,
    // SfOverlay,
    // WeChatLoginModal: () => import("~/components/General/weChatLoginModal.vue"),
    // SearchResults: () =>
    //   import(
    //     /* webpackPrefetch: true */ "~/components/Header/SearchBar/SearchResults.vue"
    //   ),
      Login,
  },
  directives: { clickOutside },
  setup() { 
    const { hasCurrencyToSelect, hasStoresToSelect } = useTopBar();
    const isSearchOpen = ref(false); 
    // const { toggleLoginModal } = useUiState();
    const productSearchResults = ref<ProductInterface[] | null>(null);  
    const closeSearchOption = () => {
      isSearchOpen.value = false;
    }; 
 

   
 
    return {
      closeSearchOption,
      
      hasCurrencyToSelect,
      hasStoresToSelect,
      isSearchOpen,
      productSearchResults, 
    };
  },
});
